import { render, staticRenderFns } from "./CollectiveShippingSplitModal.html?vue&type=template&id=4597c2d0&scoped=true&external"
import script from "./CollectiveShippingSplitModal.ts?vue&type=script&lang=ts&external"
export * from "./CollectiveShippingSplitModal.ts?vue&type=script&lang=ts&external"
import style0 from "./CollectiveShippingSplitModal.css?vue&type=style&index=0&id=4597c2d0&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4597c2d0",
  null
  
)

export default component.exports